import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const StoreContext = createContext(null);

const initialPreview = () => {
  const p = new URLSearchParams(window.location.search).get("preview");
  if (p === "1" || p === "0") localStorage.setItem("va_preview", p);
  const saved = localStorage.getItem("va_preview");
  if (saved !== null) return saved === "1";
  const h = window.location.hostname;
  return h.includes("preview.emergentagent.com") || h === "localhost";
};

export const StoreProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [preview, setPreviewState] = useState(initialPreview);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/settings`)
      .then((r) => setSettings(r.data))
      .catch(() => setSettings({}));
  }, []);

  const setPreview = (v) => {
    localStorage.setItem("va_preview", v ? "1" : "0");
    setPreviewState(v);
  };

  return <StoreContext.Provider value={{ settings, preview, setPreview }}>{children}</StoreContext.Provider>;
};

export const useStore = () => useContext(StoreContext);
